// services
import { Http } from "@shared/svelte/Modules/ApiService";

// stores
import { SuspensionStore } from "@retailer/stores/SuspensionStore";

// types
import type { HTTPParams } from "@shared/types/HTTP";

const baseUrl = "/api/retailer/provipay_suspensions";

const makeReq = async (requestData, successCB) => {
  const errCB = () => {
    SuspensionStore.update(suspensions => ({
      ...suspensions,
      loaded: true,
      failed: true,
    }));
  };

  await Http(requestData, successCB, errCB);
};

export const get = async () => {
  const requestData: HTTPParams = {
    method: "GET",
    url: baseUrl,
  };

  const successCB = json => {
    SuspensionStore.set({
      loaded: true,
      failed: false,
      suspensions: json,
    });
  };

  makeReq(requestData, successCB);
};
